import React from 'react';
import { Autocomplete, TextField } from '@mui/material';

export default function HealthFreeSoloSelect({ label, value, options, onChange, required }) {
  return (
    <Autocomplete
      freeSolo
      options={options}
      value={value || ''}
      inputValue={value || ''}
      onInputChange={(_, v) => onChange(v)}
      onChange={(_, v) => onChange(typeof v === 'string' ? v : (v || ''))}
      renderInput={(params) => (
        <TextField {...params} label={label} required={required} fullWidth />
      )}
    />
  );
}
